const flightItineraryAccordionDictionary = {
  getPaidButton: {
    text: 'Get Paid',
    tooltipText: 'Add payout information and your earnings will be deposited into your bank account.',
    disabledTooltipText: 'Must action all item requests before you can add payout information.'
  }
}

export default flightItineraryAccordionDictionary
